import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TraspasoService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getTraspasos(id: string, tipo_id: string): Observable<any> {    
    return this.http.get(this.baseUrl + 'traspasosOrigenListado/' + id + '/' + tipo_id, { headers: this.header(this.token) });
  }

  getTraspasoById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'parTipoGasto/' + id, { headers: this.header(this.token) });
  }

  postTraspasoOrigen(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'traspasoOrigen', bodyString, { headers: this.header(this.token) });
  }

  postTraspasoOrigen2(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'traspasoOrigen2', bodyString, { headers: this.header(this.token) });
  }

  putTraspasoOrigen(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'traspasoOrigen', bodyString, { headers: this.header(this.token) });
  }

  putTraspasoOrigen2(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'traspasoOrigen2', bodyString, { headers: this.header(this.token) });
  }

  deleteTraspasoOrigen(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'traspasoOrigen/' + id, { headers: this.header(this.token) });
  }

  putMesesTraspasoO(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'mesesTraspasoOrigen', bodyString, { headers: this.header(this.token) });
  }

  putRevisionTraspasoO(data: any): Observable<any> {
    return this.http.put(this.baseUrl + 'traspasoOrigenEnviarRevision', { id: data.id, estado_id: data.estado_id }, { headers: this.header(this.token) });
  }

  putAprobarTraspasoO(data: any): Observable<any> {
    return this.http.put(this.baseUrl + 'traspasoOrigenAprueba', { id: data.id, estado_id: data.estado_id }, { headers: this.header(this.token) });
  }

  // Traspasos A
  getTraspasosAprobados(id: string, tipoId): Observable<any> {
    return this.http.get(this.baseUrl + 'traspasoAListado/' + id + '/' + tipoId, { headers: this.header(this.token) });
  }

  getTraspasoByNro(id: string, idTecho: string): Observable<any> {
    return this.http.get(this.baseUrl + 'traspasoOrigenDisponible/' + id + '/' + idTecho, { headers: this.header(this.token) });
  }

  postTraspasoDestino(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'traspasoDestino', bodyString, { headers: this.header(this.token) });
  }

  postTraspasoDestino2(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'traspasoDestino2', bodyString, { headers: this.header(this.token) });
  }

  putTraspasoDestino(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'traspasoDestino', bodyString, { headers: this.header(this.token) });
  }

  putTraspasoDestino2(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'traspasoDestino2', bodyString, { headers: this.header(this.token) });
  }

  putRevisionTraspasoD(data: any): Observable<any> {
    return this.http.put(this.baseUrl + 'traspasoDestinoEnviarRevision', { id: data.id, estado_id: data.estado_id }, { headers: this.header(this.token) });
  }

  putApruebaTraspasoD(data: any): Observable<any> {
    return this.http.put(this.baseUrl + 'traspasoDestinoAprueba', { id: data.id, estado_id: data.estado_id, resolucion: data.resolucion, justificacion: data.justificaciona }, { headers: this.header(this.token) });
  }

  deleteTraspasoDestino(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'traspasoDestino/' + id, { headers: this.header(this.token) });
  }

  putMesesTraspasoD(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'mesesTraspasoDestino', bodyString, { headers: this.header(this.token) });
  }

  getTipoTraspaso(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'tipoTraspasos/' + id, { headers: this.header(this.token) });
  }

  //Requerimiento extendido
  getPartidasTraspasoOById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'partidasPorTraspasoId/' + id, { headers: this.header(this.token) });
  }

  getPartidasTraspasoDById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'partidasPorTraspasoDestinoId/' + id, { headers: this.header(this.token) });
  }

  getFuentesPartidaOById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'partidasMesesPorTareaDetalleId/' + id, { headers: this.header(this.token) });
  }

  getDescripcionTareaByTDId(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'getDescripcionTarea/' + id, { headers: this.header(this.token) });
  }

  getFuentesPartidaDById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'partidasMesesPorTareaDetalleIdDestino/' + id, { headers: this.header(this.token) });
  }

  getTraspasosPorAprobar(i_id: number, e_id: number, tipo_agregacion_id: number): Observable<any> {        
    return this.http.get(this.baseUrl + 'traspasoOrigenDestinoFiltro/' + i_id + '/' + e_id + '/' + tipo_agregacion_id, { headers: this.header(this.token) });
  }

  putObservaTraspasoPApD(data: any): Observable<any> {
    return this.http.put(this.baseUrl + 'traspasoDestinoObserva', { id: data.id, estado_id: data.estado_id }, { headers: this.header(this.token) });
  }

  getTraspasoOrigenById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'traspasoOrigenById/' + id, { headers: this.header(this.token) });
  }

  getTraspasoOrigenById2(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'traspasoOrigenById2/' + id, { headers: this.header(this.token) });
  }

  getTraspasoDestinoById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'traspasoDestinoById/' + id, { headers: this.header(this.token) });
  }

  getTraspasoDestinoById2(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'traspasoDestinoById2/' + id, { headers: this.header(this.token) });
  }

  getListPartidasTraspaso(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'listPartidasTraspaso/' + id, { headers: this.header(this.token) });
  }

  putTraspasoOrigenObserva(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'traspasoOrigenObserva', bodyString, { headers: this.header(this.token) });
  }

  putTraspasoDestinoObserva(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'traspasoDestinoObserva', bodyString, { headers: this.header(this.token) });
  }

  getTraspasoSeguimientoById(data: any): Observable<any> {
    return this.http.get(this.baseUrl + 'traspasoSeguimientoById/' + data.id + '/' + data.tipo, { headers: this.header(this.token) });
  }

  getEstadosTByUsuario(): Observable<any> {
    return this.http.get(this.baseUrl + 'estadosTraspasosByRolUser', { headers: this.header(this.token) });
  }

  putApruebaJuridica(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'traspasoApruebaJuridica', bodyString, { headers: this.header(this.token) });
  }

  putSeguimientoGral(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'traspasoSeguimientoGral', bodyString, { headers: this.header(this.token) });
  }

  getEstadosTByUsuarioSeguimiento(tipo_traspaso: number, tipo_traspaso_id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'comboEstadosTraspasosByRolUser/' + tipo_traspaso + '/' + tipo_traspaso_id, { headers: this.header(this.token) });
  }  

  getPartidasTraspasoById(id: number, tipo: string): Observable<any> {
    return this.http.get(this.baseUrl + 'partidasTraspasoById/' + id + '/' + tipo, { headers: this.header(this.token) });
  }

  putCantidadesPreciosByTraspaso(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'cantidadesPreciosByTraspaso', bodyString, { headers: this.header(this.token) });
  }

  getTraspasoPatidasByTareaId(id: number, tipo: string, idTraspasoO: number): Observable<any> {
    return this.http.get(this.baseUrl + 'traspasoPatidasByTareaId/' + id + '/' + tipo + '/' + idTraspasoO, { headers: this.header(this.token) });
  }

  getPartidasTraspasoFisico(id: number, idTraspasoO: number): Observable<any> {
    return this.http.get(this.baseUrl + 'partidasTraspasoFisico/' + id + '/' + idTraspasoO, { headers: this.header(this.token) });
  }

  getPartidasTraspasoPpto(id: number, idTraspasoO: number, idTecho: number, idFuenteEspejo: number): Observable<any> {    
    return this.http.get(this.baseUrl + 'partidasTraspasoPpto/' + id + '/' + idTraspasoO + '/' + idTecho + '/' + idFuenteEspejo, { headers: this.header(this.token) });
  }

  getAsignaJuridicaByTId(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'getAsignaJuridica/' + id, { headers: this.header(this.token) });
  }

  postAsignaJuridica(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'postAsignaJuridica', bodyString, { headers: this.header(this.token) });
  }

  getIncisosPpto(): Observable<any> {
    return this.http.get(this.baseUrl + 'getIncisosApruebaPtto', { headers: this.header(this.token) });
  }

  getArobadoJuridica(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'getArobadoJuridica/' + id, { headers: this.header(this.token) });
  }

  getArobadoFin(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'getArobadoFin/' + id, { headers: this.header(this.token) });
  }

  getObtenerMontoTraspasoOporTDFinanciador(id: number, idTO: number): Observable<any> {
    return this.http.get(this.baseUrl + 'obtenerMontoTraspasoOporTDFinanciador/' + id + '/' + idTO, { headers: this.header(this.token) });
  }

  putTraspasoAprobadoJuridica(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'updateTraspasoAprobadoJuridica', bodyString, { headers: this.header(this.token) });
  }

  postValidaPartida(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'validaPartida', bodyString, { headers: this.header(this.token) });
  }

  getTraspasosSeguimiento(): Observable<any> {
    return this.http.get(this.baseUrl + 'getTraspasosSeguimiento', { headers: this.header(this.token) });
  }

  postPartidaUE(tareaDetalle: any): Observable<any> {
    return this.http.post(this.baseUrl + 'crearPartida', tareaDetalle, { headers: this.header(this.token) });
  }

  putPartidaUE(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'actualizarPartida', bodyString, { headers: this.header(this.token) });
  }
  ///

  putFuenteIdTDF(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'actualizaridTDF', bodyString, { headers: this.header(this.token) });
  }

  revertirTraspasoDestino(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'revertirTraspasoDestino', bodyString, { headers: this.header(this.token) });
  }

}
